import { useEffect } from "react";
import { sendGtmEvent } from "~/analytics/definitions";
import Bowser from "bowser";

let observer: IntersectionObserver | undefined;
if (typeof IntersectionObserver !== "undefined") {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sendImpressionEvent = async () => {
            const { default: isArkitSupported } = await import(
              "~/common/helpers/isArkitSupported"
            );
            const testid = entry.target.getAttribute("data-testid");
            // AR is only spported on specific versions of iOS devices
            if (isArkitSupported()) {
              if (testid === "data-3dmodel-mobile-button") {
                sendGtmEvent({
                  event: "3DAREvent",
                  eventAction: "See in 3D Impression",
                });
              }
            } else {
              if (Bowser.mobile) {
                sendGtmEvent({
                  event: "3DAREvent",
                  eventAction: "Mobile Impression",
                });
              } else {
                sendGtmEvent({
                  event: "3DAREvent",
                  eventAction: "Desktop Impression",
                });
              }
            }
          };
          sendImpressionEvent();
          observer?.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.8 },
  );
}

export const use3DImpressionTracking = (ref: React.RefObject<HTMLElement>) => {
  useEffect(() => {
    const refItem = ref.current;
    if (refItem && observer) {
      observer.observe(refItem);
    }
    return () => {
      if (refItem && observer) {
        observer.unobserve(refItem);
      }
    };
  }, [ref]);
};
